import { filterDuplicates } from '@nu-art/ts-common';
import { smartDocParamType_Static, smartDocStaticParamType_Attribute, smartDocStaticParamType_Finding, smartDocStaticParamType_Tag, smartDocStaticParamType_Template } from './static/index.js';
export const smartDocParamDependencyExtractor = (params) => {
    const dependencies = {
        _variableIds: [],
        _tagIds: [],
        _logTemplateIds: [],
    };
    params.forEach(param => {
        if (param.type !== smartDocParamType_Static)
            return;
        switch (param.subType) {
            case smartDocStaticParamType_Finding:
            case smartDocStaticParamType_Attribute:
                dependencies._variableIds.push(param.id);
                break;
            case smartDocStaticParamType_Tag:
                dependencies._tagIds.push(param.id);
                break;
            case smartDocStaticParamType_Template:
                dependencies._logTemplateIds.push(param.id);
                break;
        }
    });
    return {
        _variableIds: filterDuplicates(dependencies._variableIds),
        _tagIds: filterDuplicates(dependencies._tagIds),
        _logTemplateIds: filterDuplicates(dependencies._logTemplateIds),
    };
};
//# sourceMappingURL=utils.js.map